import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

export const useSessionsQCM = (filters = {}, refresh) => {
  let urlfetch = `${url}sessions-qcm/`;
  const params = Object.entries(filters).filter(([, v]) => v);
  if (params.length > 0) {
    const queryString = params
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    urlfetch += `?${queryString}`;
  }
  return useApi(urlfetch, [], refresh);
};
